/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";
import { formatNumber } from "helper/Common/CommonHelper";

const OpportunityHeader = ({
  reloadList = () => {},
  downloadAsExcel = () => {},
  invoiceList = [],
  followingOpportunityCount = 0,
  totalNotesCount = 0,
  teamCount = 0,
  totalValueCount = 0,
  jsonFilterQuery = [],
  selectedInvoiceIds = [],
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [{ title: t("Opportunity") }];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          {/* --- breadcrumb start --- */}
          <BreadCrumb breadCrumbText={breadcrumbText} bottom={true} />
          {/* --- breadcrumb end --- */}
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <div className="d-flex gap-2 align-items-center me-2">
            <ul className="d-flex align-items-center gap-2">
              <li role="presentation">
                Opportunities :{" "}
                <span className="text-primary">{invoiceList.length}</span>
              </li>
              <li role="presentation">
                Following :{" "}
                <span className="text-primary">
                  {followingOpportunityCount}
                </span>
              </li>

              <li role="presentation">
                Notes : <span className="text-primary">{totalNotesCount}</span>
              </li>

              <li role="presentation">
                Team : <span className="text-primary">{teamCount}</span>
              </li>

              <li role="presentation">
                Total :{" "}
                <span className="text-primary">
                  {formatNumber(totalValueCount)}
                </span>
              </li>
            </ul>
          </div>

          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>

          {/* <!-- ========== Start view switch Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("List View")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/opportunity/list`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    list
                  </span>
                  <span className="d-block">{t("List View")}</span>
                </Link>
              </li>
              {/* <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-1"
                  to={`/admin/crm/opportunity/kanban`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">{t("Kanban View")}</span>
                </Link>
              </li> */}
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/opportunity/kanbankit`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">{t("Kanban View")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <!-- ========== End view switch Section ========== --> */}

          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedInvoiceIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle="modal"
                  data-bs-target="#addLabelModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedInvoiceIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#addFollowers"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person
                  </span>
                  <span className="d-block">{t("Add Followers")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="#"
                  onClick={downloadAsExcel}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    download
                  </span>
                  <span className="d-block">{t("Download as XLS")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2  ${
                    selectedInvoiceIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#deletewarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            // data-bs-target="#offcanvasInvoiceListFilter"
            // aria-controls="offcanvasInvoiceListFilter"
            data-bs-target="#opportunityAdvFilter"
            aria-controls="opportunityAdvFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>
          <Link
            to="#"
            data-bs-toggle="offcanvas"
            data-bs-target="#addNewInvoice"
            aria-controls="addNewInvoice"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span className="d-block">{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OpportunityHeader;
